'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = CardsDisplay;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function CardsDisplay(p) {

    var propTypes = {
        'type': _react.PropTypes.string
    };

    var CARD_TYPES = [{ 'long': 'MasterCard', 'short': 'mastercard' }, { 'long': 'Visa', 'short': 'visa' }, { 'long': 'American Express', 'short': 'amex' }, { 'long': 'Discover', 'short': 'discover' }];

    var cardImages = CARD_TYPES.map(function (type, i) {
        return _react2['default'].createElement('img', { key: i, src: _hfReactHelper2['default'].imgHelper('api/pricing/upgrade_popup/' + type.short + '_' + (p.type == type.long ? '' : 'in') + 'active.png') });
    });

    return _react2['default'].createElement(
        'div',
        { className: 'm-payment--ccs' },
        cardImages
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/cards-display.jsx
 ** module id = 1124
 ** module chunks = 0
 **/